import './index.scss';
import PropTypes from 'prop-types';
import React from 'react';
import GoogleMapsService from 'services/google_maps';

class Map extends React.PureComponent {
  static displayName = 'Map';

  static propTypes = {
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    zoom: PropTypes.number,
    mapType: PropTypes.string,
    mapTypeControl: PropTypes.bool,
    panControl: PropTypes.bool,
    scaleControl: PropTypes.bool,
    streetViewControl: PropTypes.bool,
    zoomControl: PropTypes.bool,
    zoomControlOptions: PropTypes.object,
    overviewMapControl: PropTypes.bool,
    scrollwheel: PropTypes.bool,
    includeMarker: PropTypes.bool,
    markerOptions: PropTypes.object,
  };

  static defaultProps = {
    zoom: 14,
    mapType: window.google && window.google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    panControl: false,
    scaleControl: false,
    streetViewControl: false,
    draggable: true,
    zoomControl: true,
    zoomControlOptions: {
      style: window.google && window.google.maps.ZoomControlStyle.SMALL,
    },
    overviewMapControl: false,
    scrollwheel: false,
    includeMarker: true,
    markerOptions: {
      title: '',
    },
  };

  componentDidMount() {
    GoogleMapsService.onReady(this._initMap);
  }

  _initMap = () => {
    var map = new google.maps.Map(this.refs.mapCanvas, this._mapOptions());
    if (this.props.includeMarker) {
      this._addMarker(map);
    }
  };

  _mapOptions = () => {
    return {
      center: this._point(),
      zoom: this.props.zoom,
      mapTypeId: this.props.mapType,
      mapTypeControl: this.props.mapTypeControl,
      panControl: this.props.panControl,
      scaleControl: this.props.scaleControl,
      streetViewControl: this.props.streetViewControl,
      draggable: this.props.draggable,
      zoomControl: this.props.zoomControl,
      zoomControlOptions: this.props.zoomControlOptions,
      overviewMapControl: this.props.overviewMapControl,
      scrollwheel: this.props.scrollwheel,
    };
  };

  _point = () => {
    return new google.maps.LatLng(this.props.latitude, this.props.longitude);
  };

  _addMarker = (map) => {
    return new google.maps.Marker({
      map: map,
      position: this._point(),
      title: this.props.markerOptions.title,
    });
  };

  render() {
    return <div id="map_canvas" ref="mapCanvas"></div>;
  }
}

export default Map;
